
define('text!templates/parts/tree/tree-item.html',[],function () { return '<div class="item-label">\n    <span class="fa {{#subgroup}}tree-item-toggle fa-chevron-right{{/subgroup}}{{^subgroup}}fa-square{{/subgroup}}"></span><span class="text">{{label}}</span>\n</div>\n<ul class="tree-view"></ul>\n';});

